import React from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const KPISet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const { getComparableTimeframe } = useDates();

    return (drawable && <>
        {/* filterModel in KPISet
        <JSONPretty data={filterModel} className="json-wrapper" /> */}
        <Box className="mtska-kpi-set">
            <KPI
                title="Commission Deals"
                icon="faHandshake"
                dataProviderName={'statistics/item/count/administrations/revenuedeal'}
                filters={filterModel}
            />
            <KPI
                title="Commission Rulesets"
                icon="faBallotCheck"
                dataProviderName={'statistics/item/count/administrations/revenueruleset'}
                filters={filterModel}
            />
            <KPI
                title="Commission Rules"
                icon="faCheck"
                dataProviderName={'statistics/item/count/administrations/revenuerule'}
                filters={filterModel}
            />
        </Box>
    </>
    )
}

export default KPISet;